import { render, staticRenderFns } from "./comp_SongSection.vue?vue&type=template&id=344d294e&"
import script from "./comp_SongSection.vue?vue&type=script&lang=js&"
export * from "./comp_SongSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports